import {
  Button,
  Card,
  Checkbox,
  DatePicker,
  Form,
  Tag,
  Input,
  Select,
  Row,
  Col,
} from "antd";
import React, { useState } from "react";

const UnitTurnDetails = ({ data }) => {
  const [isEditActive, setIsEditActive] = useState(false);
  const { TextArea } = Input;
  return (
    <div>
      <Card
        title="Details"
        extra={
          !isEditActive ? (
            <Button
              type="link"
              onClick={() => {
                setIsEditActive(true);
              }}
            >
              Edit
            </Button>
          ) : (
            ""
          )
        }
      >
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          initialValues={{
            remember: true,
          }}
          autoComplete="off"
          colon={false}
        >
          <Form.Item label="Unit">
            <p>{data?.unitName === "" ? "--" : data?.unitName}</p>
          </Form.Item>
          <Form.Item label="Move-Out Date">
            <p>{data?.moveOutDate === "" ? "--" : data?.moveOutDate}</p>
          </Form.Item>
          <Form.Item label="Move-In Date">
            <p>{data?.moveInDate === "" ? "--" : data?.moveInDate}</p>
          </Form.Item>
          <Form.Item label="Unit Availability Date">
            <p>{data?.moveInDate === "" ? "--" : data?.moveInDate}</p>
          </Form.Item>

          <Form.Item label=" ">
            {isEditActive ? (
              <DatePicker format="MM-DD-YYYY" style={{ width: "100%" }} />
            ) : data?.isRentReady ? (
              ""
            ) : (
              ""
            )}
          </Form.Item>
          <Form.Item label="Target Turnaround Date">
            <p>{data?.moveInDate === "" ? "--" : data?.moveInDate}</p>
          </Form.Item>
          <Form.Item label="Date Completed">
            <p>{data?.moveInDate === "" ? "--" : data?.moveInDate}</p>
          </Form.Item>
          <Form.Item label="Reference">
            <p>{data?.moveInDate === "" ? "--" : data?.moveInDate}</p>
          </Form.Item>
          <Form.Item label="Notes">
            {isEditActive ? <TextArea /> : data?.isRentReady ? "Yes" : "No"}
          </Form.Item>

          {isEditActive && (
            <Row gutter={16}>
              <Col>
                <Button
                  type="primary"
                  onClick={() => {
                    setIsEditActive(false);
                  }}
                >
                  Save
                </Button>
              </Col>
              <Col>
                <Button
                  onClick={() => {
                    setIsEditActive(false);
                  }}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          )}
        </Form>
      </Card>
    </div>
  );
};

export default UnitTurnDetails;
